import { combineReducers, configureStore, createListenerMiddleware } from "@reduxjs/toolkit"
import { attendeeSlice } from "reducers/attendeeSlice"
import { dataViewPreferencesSlice } from "reducers/dataViewPreferencesSlice"
import { profileSlice, signOut } from "reducers/profileSlice"
import { themeSlice } from "reducers/themeSlice"
import { persistReducer, persistStore } from "redux-persist"
import { default as storage } from "redux-persist/lib/storage"

const rootReducer = combineReducers({
  [attendeeSlice.name]: attendeeSlice.reducer,
  [dataViewPreferencesSlice.name]: dataViewPreferencesSlice.reducer,
  [profileSlice.name]: profileSlice.reducer,
  [themeSlice.name]: themeSlice.reducer,
})

const persistedReducer = persistReducer({ key: "root", storage }, rootReducer)
const listenerMiddleware = createListenerMiddleware()

export const store = configureStore({
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({ serializableCheck: false }).prepend(listenerMiddleware.middleware)
  },
  reducer: persistedReducer,
})

export const persistor = persistStore(store)

listenerMiddleware.startListening({
  actionCreator: signOut,
  effect: async () => {
    await persistor.flush()
    await persistor.purge()
  },
})

export type RootState = ReturnType<typeof store.getState>
